import { COMMON_EMAIL_DOMAINS } from "@/constants";
import { UseFormReturn, FieldValues } from "react-hook-form";
import * as levenshtein from "fast-levenshtein";

export const validateEmailWatcher = async (
  email: string | undefined,
  form: UseFormReturn<FieldValues, any>,
) => {
  if (!email) return;

  const isFormEmailValid = await form.trigger("email");
  if (!isFormEmailValid) {
    const { error } = form.getFieldState("email");
    form.setError("email", { message: error?.message || "Invalid email" });
  } else {
    form.clearErrors("email");
  }
};

export const validateAndSuggestEmailDomain = (email: string) => {
  const [_localPart, domain] = email.split("@");

  if (!domain || domain.trim() === "") {
    return { isValid: false, suggestedDomain: null };
  }

  const normalizedDomain = domain.toLowerCase();

  // Calculate Levenshtein distance for each common domain
  const domainDistances = COMMON_EMAIL_DOMAINS.map((commonDomain) => ({
    domain: commonDomain.toLowerCase(),
    distance: levenshtein.get(normalizedDomain, commonDomain.toLowerCase()),
  }));

  // Sort domains by distance and select the closest match
  const closestDomain =
    domainDistances.sort((a, b) => a.distance - b.distance).find(({ distance }) => distance <= 3)
      ?.domain || null;

  const isValid = closestDomain === null || normalizedDomain === closestDomain;

  return {
    isValid: isValid,
    suggestedDomain: closestDomain || null,
  };
};
